export default "<ion-app class=\"app-component\">\r\n  <ion-router-outlet></ion-router-outlet>\r\n</ion-app>\r\n";